export class RecentSearchItem {
    searchTerm: string;
    type: string | null | undefined;

    constructor(searchTerm: string, type: string | null | undefined) {
        this.searchTerm = searchTerm;
        this.type = type;
    }
}